import { useTranslations } from "next-intl";
import { memo } from "react";
import { Button } from "@components/core";

const CatalogFiltersFooter = memo(function CatalogFiltersFooter({
  clearFiltersAndClose,
  closeFilters,
  resultsCount,
}) {
  const t = useTranslations("catalog");

  return (
    <div className="catalog-filters-footer">
      <div className="py-2">
        <p className="mb-0 text-center font-size-sm text-gray">
          {t("filters.results", { count: resultsCount || 0 })}
        </p>
      </div>
      <div className="bg-white d-flex flex-column gap-2 p-3">
        <Button
          fullWidth
          onClick={closeFilters}
        >
          {t("filters.apply")}
        </Button>
        <Button
          variant="ghost-primary"
          fullWidth
          onClick={clearFiltersAndClose}
        >
          {t("filters.delete")}
        </Button>
      </div>
    </div>
  );
});

export default CatalogFiltersFooter;
